import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';

import useUser from 'hooks/useUser';
import updateUser from 'api/user/updateUser';
import userInfoSchema from 'schemas/userInfoSchema';

interface FormValues {
  userName: string;
  description: string;
}

const useUpdateUserInfo = () => {
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const user = useUser();
  const useFormReturn = useForm<FormValues>({
    defaultValues: {
      userName: user.data?.userName,
      description: user.data?.description,
    },
    resolver: yupResolver(userInfoSchema),
  });

  const updateMutation = useMutation({
    mutationFn: updateUser,
    onSuccess: (_, { userName, description }) => {
      user.update({
        userName,
        description,
      });
      setIsUpdateMode(false);
    },
    onError: (error: any) => {
      if (error?.message === '11004') {
        useFormReturn.setError('userName', { message: '이미 존재하는 아이디입니다.' });
      }
    },
  });

  const handleUpdateModeButtonClick = () => {
    setIsUpdateMode(true);
  };

  const onValid = (values: FormValues) => {
    if (user.data?.userName === values.userName && user.data.description === values.description) {
      return setIsUpdateMode(false);
    }
    updateMutation.mutate({ userName: values.userName, description: values.description });
  };

  return {
    user: user.data,
    isUpdateMode,
    useFormReturn,
    isLoading: updateMutation.isPending,
    onUpdateModeButtonClick: handleUpdateModeButtonClick,
    onValid,
  };
};

export default useUpdateUserInfo;
